import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const styles = theme => ({
    Card: {
        margin: '-8px',
        minWidth: '300px',
        maxWidth: '450px'
    },
    nameContainer: {
        display: 'flex',
        alignItems: 'center',
        color: '#3A3A3A',
        fontSize: '16px',
        lineHeight: '56px',
        fontWeight: 700,
        height: '56px'
        },
    content: {
        padding: '15px',
        paddingBottom: '20px',
    },
    avatar: {
        backgroundColor: '#0A54A2',
        float: 'left',
        marginRight: '12px',
        height: '32px',
        width: '32px'
    },
    name: {
        float: 'left',
        lineHeight: '32px'
    },
    header:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #E6EDF5',
        padding: '0 15px',
    }

});


const Card = (props) => {
    const { classes, extraItem, title, avatar } = props;
    return (
        <div className={classes.Card}>
            <div className={classes.header}>
                {avatar || title ? <div className={classes.nameContainer}>
                    {avatar ? <Avatar className={classes.avatar}>{avatar}</Avatar> : ''}
                    {title ? <div className={classes.name}>{title}</div> : ''}
                </div> : ''}
                <div className={classes.extraContainer}>
                    {extraItem ? extraItem: ''}
                </div>
            </div>
            <div className={classes.content}>
                {props.children}
            </div>
        </div>
    )
}
export default withStyles(styles)(Card);

